export default __webpack_public_path__ + "static/media/logo@2x.3f967231.png";